import React from 'react';
import Staf from './staff';
import Tabs from './tabs';
import BusinessModelsSection from '../businessModels';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect, useState } from 'react';
import { Helmet } from "react-helmet-async";
import Service from '../../../../assests/service.png'
import bgimage from '../../../../assests/webiconF (3)/3.png'

const Web_devlopment = () => {
  const [message, setMessage] = useState('');
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    phone: '',
    email: '',
  });

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: true, // whether animation should happen only once
    });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const validate = () => {
    let newErrors = {};
    if (!formData.phone.trim()) newErrors.phone = 'Phone is required';
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    return newErrors;
  };

  //   const handleSubmit = (e) => {
  //     e.preventDefault();
  //     const newErrors = validate();
  //     setErrors(newErrors);

  //     if (Object.keys(newErrors).length === 0) {
  //       setMessage('Message sent successfully!');
  //       console.log('Form Submitted:', formData);
  //       setFormData({
  //         type:'Wep Application',
  //         phone: '',
  //         email: '',
  //       });
  //     } else {
  //       setMessage('');
  //     }
  //   };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length === 0) {
      try {
        // Add a "type" to formData before sending
        const payload = {
          ...formData,
          type: 'Web_Application',
        };

        const response = await fetch('https://www.tekitsolution.com/email_apis.php?action=service', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams(payload).toString(),
        });

        const result = await response.json();
        alert('Form submitted successfully!');

        // Reset form
        setFormData({
          type: 'Wep_Application',
          phone: '',
          email: '',
        });
        setMessage('Message sent successfully!');
        setErrors({});
      } catch (error) {
        console.error('Error:', error);
        alert('Something went wrong. Please try again.');
      }
    } else {
      setErrors(validationErrors);
      setMessage('');
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelect = (index) => {
    setActiveIndex(index)
  }

  return (
    <div className=''>
      <Helmet>
        <title>Custom Web Development Services | Tekit  </title>
        <meta name="description" content="From startups to enterprises, Tekit delivers world-class web development — cleans code, stunning design, and results that speak for themselves." />
        <meta name="keywords" content="Web Development Services, Custom Web Development, Responsive Web Design, Front-End Development, Back-End Development, Full-Stack Web Development, E-Commerce Web Development, Top IT Staff Augmentation Companies, IT Staffing Services, Largest IT Staffing Companies, Staffing IT, Contract IT Staffing, Staffing IT Services, IT Staffing, Staffing Solutions, IT Staffing Solutions, Premier Staffing Solutions, IT Services, Executive Staffing, Staffing Company, staffing services" />
      </Helmet>
      <div className="curslide">
        <div
          className="w-full h-[500px] lg:h-[380px] bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${Service})` }}
        // style={{
        //     backgroundImage: `linear-gradient(to right, rgba(254, 247, 237, 1), rgba(255, 255, 255, 0)), url('https://static.zohocdn.com/sites/stock-images/images/zpstock-image-39.jpg')`,
        // }}
        ></div>

        <div className="absolute top-0 left-0 w-full h-full flex items-start justify-start text-center">
          <div className="container mx-auto px-4 py-8 text-center">
            <div className="flex flex-col justify-start items-start h-full text-center" style={{ placeItems: 'center' }}>
              <div className="w-full  mt-52 lg:mt-[100px]">
                <div className=' flex justify-center items-center'>
                  <img src={bgimage} className="w-20" alt='bgimage'/>
                </div>
               <h1
      data-aos="fade-up"
      className="text-center font-bold text-black -mt-6 font-recoleta text-[50px] 2xl:text-[50px] lg:text-[46px]"
    >
      Custom Web Development Services That Drive Real Results
    </h1>

    {/* Supporting SEO Heading */}
    <h2 className="text-bold text-[28px] lg:text-[24px] 2xl:text-[28px] text-center text-black mt-4">
      From Startups to Enterprises — Web Development That Scales with You
    </h2> </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <Staf />
        <Tabs />
        <BusinessModelsSection />
        <div className="p-4 lg:p-10 lg:px-48 px-10 bg-white font-recoleta">
          <h2 data-aos="fade-up" className="text-[54px] 2xl:text-[40px] lg:text-[32px] text-center font-bold text-[#002856] mb-8 font-recoleta">
            Schedule Call
          </h2>

          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

              <div>
                <input
                  data-aos="fade-up"
                  name="email"
                  placeholder="Email *"
                  className="w-full border border-gray-300 p-4 rounded text-[32px] lg:text-[20px]"
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && <p className="text-red-500 text-[24px] lg:text-sm">{errors.email}</p>}
              </div>

              <div>
                <input
                  data-aos="fade-up"
                  name="phone"
                  placeholder="Phone"
                  className="w-full border border-gray-300 p-4 rounded text-[32px] lg:text-[20px]"
                  value={formData.phone}
                  onChange={handleChange}
                />
                {errors.phone && <p className="text-red-500 lg:text-sm text-[24px]">{errors.phone}</p>}

              </div>
            </div>

            <div className="justify-center items-center gap-4 mt-6 grid grid-cols-1 px-10  lg:hidden justify-self-center">
              <button
                type="submit"
                className="bg-[#00447b] w-full text-white py-2 px-6 rounded-full hover:bg-[#00325c] duration-300 text-[28px] lg:text-[20px]"
              >
                Submit
              </button>
            </div>
            <div className="justify-center ite gap-4 mt-6 lg:flex px-10 lg:block hidden">
              <button
                type="submit"
                data-aos="fade-up"
                className="bg-[#00447b] lg:w-52 w-full text-white py-2 px-6 rounded-full hover:bg-[#00325c] duration-300"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Web_devlopment;